import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type SettingsState = {
  setting: boolean;
}

const initialState: SettingsState = {
  setting: false,
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setSetting: (state, action: PayloadAction<boolean>) => {
      state.setting = action.payload;
    },
  },
});

export default settingsSlice;
